// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__14eF1","options":"AnswerScale_options__2I83W","selected":"AnswerScale_selected__GSm4B"};